import React from "react";
import { Box, AppBar, Toolbar, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";

const SidebarLayout = ({ children }) => {
  const location = useLocation();

  const getPageTitle = () => {
    switch (location.pathname) {
      case "/":
        return "Parametric Costing - AI Powered";
      case "/aiCostStudio":
        return "F&B - Analytics Workspace";
      case "/bpch":
        return "BPCH Parametric Costing - AI Powered";
      case "/mechanical":
        return "Mechanical Engineering Costing";
      case "/electronics":
        return "Electronics Costing";
      case "/packaging":
        return "Packaging Costing";
      // case "/Landing-Page":
      //   return "Food & Beverages Costing";
      // case "/should-costing":
      //   return "Should Costing Calculator";
      // case "/ingredients":
      //   return "Ingredients Management";
      // case "/prices":
      //   return "Price Management";
      // case "/playbook":
      //   return "PlayBook — Cost Modelling";
      // case "/costAnalysisReports":
      //   return "Cost Analysis Reports";
      default:
        return "Parametric Costing - AI Powered";
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      {/* Sidebar */}
      <Sidebar
        sx={{
          background: "#D2D2D2",
          color: "#000",
        }}
      />

      {/* Main content area */}
      <Box
        sx={{
          flexGrow: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          overflow: "hidden",
        }}
      >
        {/* Top App Bar */}

        {/* Page Content */}
        <Box
          sx={{
            flexGrow: 1,
            overflow: "auto",
            p: 3,
            height: "calc(100vh - 64px)",
            minWidth: 0,
            maxWidth: "100%",
            boxSizing: "border-box",
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default SidebarLayout;
